<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel flex relative">
        <GmapMap
          ref="myMarker"
          :center="gmCenter"
          :zoom="gmZoom"
          map-type-id="roadmap"
          allowfullscreen
          style="height: 100%; width: 100%;"
        >
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen=false"
          >{{infoContent}}</gmap-info-window>
          <GmapMarker
            :key="index"
            v-for="(m, index) in gmMarkers"
            :position="m.position"
            :icon="m.icon"
            :clickable="true"
            :draggable="false"
            @click="toggleInfoWindow(m, index)"
          />
        </GmapMap>
        <div class="map-select-layout-active flex">
          <label title="CONSULTANTS ACTIVE" @click="showConsultantsActive">
            <i
              class="material-icons align-middle"
              :class="{'active' : activeConsultants}"
            >{{activeConsultants ? 'check_box' : 'check_box_outline_blank'}}</i>
            CONSULTANTS ACTIVE
          </label>
          <label title="CLIENTS INACTIVE" @click="showConsultantsInactive">
            <i
              class="material-icons align-middle"
              :class="{'active' : inactiveConsultants}"
            >{{inactiveConsultants ? 'check_box' : 'check_box_outline_blank'}}</i>
            CONSULTANTS INACTIVE
          </label>
          <div class="map-tech-level-selector">
            <model-select
              class="map-tech-level-selector-height"
              :options="techLevelOptions"
              placeholder="Tech Level"
              v-model="selectedTechLevel"
            ></model-select>
          </div>
        </div>
        <div class="map-select-layout-active map-select-layout-active-company flex">
          <label title="COMPANIES" @click="showCompaniesActive">
            <i
              class="material-icons align-middle"
              :class="{'active' : activeCompanies}"
            >{{activeCompanies ? 'check_box' : 'check_box_outline_blank'}}</i>
            COMPANIES ACTIVE
          </label>
          <label title="COMPANIES" @click="showCompaniesInactive">
            <i
              class="material-icons align-middle"
              :class="{'active' : inactiveCompanies}"
            >{{inactiveCompanies ? 'check_box' : 'check_box_outline_blank'}}</i>
            COMPANIES INACTIVE
          </label>
        </div>
      </div>

      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelCompany
            v-if="editOpen == 1"
            :id="companyId"
            :name="companyName"
            :email="companyEmail"
            :billingEmail="companyBillingEmail"
            :rate="companyRate"
            :isActive="companyIsActive"
            :stripeId="companyStripeId"
            :about="companyAbout"
          ></PanelCompany>
          <PanelConsultant
            v-if="editOpen == 2"
            :id="consultantId"
            :name="consultantName"
            :email="consultantEmail"
            :isActive="consultantIsActive"
            :phoneNumber="consultantPhonNumber"
            :address="consultantAddress"
            :metro="consultantMetro"
            :rate="consultantRate"
            :bio="consultantBio"
            :photo="consultantPhoto"
            :techLevel="consultantTechLevel"
          ></PanelConsultant>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import EditPannel from "@/components/EditPannel.vue";
import PanelCompany from "@/components/admin/map/PanelCompany.vue";
import PanelConsultant from "@/components/admin/map/PanelConsultant.vue";
import { db } from "@/vendor/firebase";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  data() {
    return {
      locations: [],
      companies: [],
      consultants: [],
      idToCompany: {},

      gmMarkers: null,
      gmMarkersCompanies: null,
      gmMarkersConsultants: null,

      infoContent: [],
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },

      companyId: null,
      companyName: null,
      companyEmail: null,
      companyBillingEmail: null,
      companyRate: null,
      companyIsActive: null,
      companyStripeId: null,
      companyAbout: null,
      companyMark: null,

      consultantId: null,
      consultantName: null,
      consultantEmail: null,
      consultantIsActive: null,
      consultantPhonNumber: null,
      consultantAddress: null,
      consultantMetro: null,
      consultantRate: null,
      consultantBio: null,
      consultantPhoto: null,
      consultantTechLevel: null,

      editOpen: false,

      activeConsultants: true,
      inactiveConsultants: true,
      activeCompanies: true,
      inactiveCompanies: true,

      gmZoom: 5,
      gmCenter: { lat: 38, lng: -96 },

      techLevels: null,
      selectedTechLevel: "All",
      techLevelOptions: []
    };
  },
  components: {
    EditPannel,
    PanelCompany,
    PanelConsultant,
    ModelSelect
  },
  watch: {
    locations: function() {
      this.updateMap();
    },
    consultants: function() {
      this.updateMap();
    },
    companies: function() {
      this.updateIdToCompany();
      this.updateMap();
    },
    techLevels: function() {
      this.updateTechLevel();
    },
    selectedTechLevel: function() {
      this.updateMap();
    }
  },
  beforeMount() {
    this.$bind("locations", db.collection("locations"));
    this.$bind("companies", db.collection("companies"));
    this.$bind("consultants", db.collection("consultants"));
    this.$bind("techLevels", db.collection("tech_levels"));
  },
  methods: {
    updateTechLevel: function() {
      this.techLevelOptions = [];
      for (const index in this.techLevels) {
        this.techLevelOptions.push({
          text: this.techLevels[index].name,
          value: this.techLevels[index].name
        });
      }
      this.techLevelOptions.push({
        text: "All",
        value: "All"
      });
      this.techLevelOptions.push({
        text: "null",
        value: null
      });
      this.techLevelOptions.sort((a, b) => {
        if (a.order === null || a.order === undefined) return 1;
        if (b.order === null || b.order === undefined) return -1;
        return a.order - b.order;
      });
    },
    updateIdToCompany: function() {
      const idToCompany = {};
      this.companies.forEach(item => {
        idToCompany[item.id] = item;
      });
      this.idToCompany = idToCompany;
    },
    showConsultantsActive: function() {
      this.activeConsultants = !this.activeConsultants;
      this.updateMap();
    },
    showConsultantsInactive: function() {
      this.inactiveConsultants = !this.inactiveConsultants;
      this.updateMap();
    },
    showCompaniesActive: function() {
      this.activeCompanies = !this.activeCompanies;
      this.updateMap();
    },
    showCompaniesInactive: function() {
      this.inactiveCompanies = !this.inactiveCompanies;
      this.updateMap();
    },
    showCompanyPannel: function(param) {
      this.companies.forEach(item => {
        if (item.id == param.company) {
          let tmpMark = param.position.lat + "|" + param.position.lng;
          if (this.companyMark != tmpMark) {
            this.closeEditPannel();
          }
          this.companyMark = tmpMark;
          this.companyId = item.id;
          this.companyName = item.name ? item.name : "";
          this.companyEmail = item.email ? item.email : "";
          this.companyBillingEmail = item.billing_email
            ? item.billing_email
            : "";
          this.companyRate = item.rate ? item.rate : "";
          this.companyIsActive = item.is_active ? "True" : "False";
          this.companyStripeId = item.stripeId ? item.stripeId : "";
          this.companyAbout = item.about ? item.about : "";
          this.openEditPannel(1, true);
          return;
        }
      });
    },
    showConsultantPannel: function(id) {
      this.consultants.forEach(item => {
        if (item.id == id) {
          if (this.consultantId != id) {
            this.closeEditPannel();
          }
          this.consultantId = id;
          this.consultantName = item.name ? item.name : "";
          this.consultantEmail = item.email ? item.email : "";
          this.consultantIsActive = item.is_active ? "true" : "false";
          this.consultantPhonNumber = item.phone_number
            ? item.phone_number
            : "";
          this.consultantAddress = item.address ? item.address : "";
          this.consultantMetro = item.metro ? item.metro : "";
          this.consultantRate = item.rate ? item.rate : "";
          this.consultantBio = item.bio ? item.bio : "";
          this.consultantPhoto = item.photo_url ? item.photo_url : "";
          this.consultantTechLevel = item.tech_level ? item.tech_level : "";
          this.openEditPannel(2, true);
          return;
        }
      });
    },
    // edit pannel: control open which component
    openEditPannel: function(action, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
    },
    closeEditPannel: function() {
      this.editOpen = false;
    },
    updateMap: function() {
      this.gmMarkersCompanies = [];
      // if (this.activeCompanies) {
      for (const index in this.locations) {
        if (
          this.locations[index].lat_lng &&
          ((this.activeCompanies &&
            this.idToCompany[this.locations[index].company] &&
            this.idToCompany[this.locations[index].company].is_active) ||
            (this.inactiveCompanies &&
              this.idToCompany[this.locations[index].company] &&
              !this.idToCompany[this.locations[index].company].is_active))
        ) {
          this.gmMarkersCompanies.push({
            position: {
              lat: this.locations[index].lat_lng.lat,
              lng: this.locations[index].lat_lng.lng
            },
            infoText:
              this.idToCompany[this.locations[index].company].name +
              (this.locations[index].name
                ? ": " + this.locations[index].name
                : ""),
            company: this.locations[index].company,
            type: "company",
            icon: { url: require("../../assets/image/ico_company.png") }
          });
        }
      }
      // }
      this.gmMarkersConsultants = [];

      for (const index in this.consultants) {
        if (
          this.consultants[index].lat_lng &&
          ((this.activeConsultants && this.consultants[index].is_active) ||
            (this.inactiveConsultants && !this.consultants[index].is_active)) &&
          (this.selectedTechLevel == "All" ||
            this.selectedTechLevel == this.consultants[index].tech_level)
        ) {
          this.gmMarkersConsultants.push({
            position: {
              lat: this.consultants[index].lat_lng.lat,
              lng: this.consultants[index].lat_lng.lng
            },
            infoText:
              "consultant" +
              (this.consultants[index].name
                ? ": " + this.consultants[index].name
                : ""),
            consultant: this.consultants[index].id,
            type: "consultant",
            icon: { url: require("../../assets/image/ico_consultant.png") }
          });
        }
      }
      this.gmMarkers = this.gmMarkersCompanies.concat(
        this.gmMarkersConsultants
      );
      // console.log(this.gmMarkers);
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.editOpen;
        // this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
      if (marker.type == "company") {
        this.showCompanyPannel(marker);
      } else if (marker.type == "consultant") {
        this.showConsultantPannel(marker.consultant);
      }
    }
  }
};
</script>